export default "__VITE_ASSET__625ff01e__"